<template>
    <v-dialog :value="dialog" fullscreen persistent hide-overlay transition="dialog-bottom-transition">
        <addSupplierOrderPosition></addSupplierOrderPosition>
    </v-dialog>
</template>

<script>
    import addSupplierOrderPosition from './AddSupplierOrderPosition.vue'
    
    import {
        SupplierOrderPosition
    } from '../../../store/namespace-helper'

    export default {
      name: 'AddSupplierOrderPositionDialog',
      components: {
        addSupplierOrderPosition
      },
      data () {
        return {}
      },
      methods: {},
      computed: {
        dialog () {
          return this.$store.getters[SupplierOrderPosition.getters.getOpenDialogState]
        }
      },
      beforeDestroy () {

      }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/SupplierOrders/SupplierOrderPositions/AddSupplierOrderPositionDialog.vue